import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";

import { customErrorSchema } from "~/common/types";
import { cancelVerificationCode } from "~/patients/api/verificationCode";

export const useCancelVerificationCode = () => {
  return useMutation({
    mutationFn: cancelVerificationCode,
    onError: (error) => {
      const result = customErrorSchema.safeParse(error);
      if (result.success) {
        toast.error(result.data.response.data.detail);
      }
    },
  });
};
